<template>
  <div>
    <div class="flex align-items-center">
      <div class="flex-fill">
        <h2 class="h4 mrgt0">
          {{ $t('calls-history.missed.title') }} ({{ missedCalls.length }})
        </h2>
      </div>
      <Btn
        v-if="missedCalls.length"
        data-test="callback-delete-button"
        class="btn--link"
        variant="bare"
        @click="deleteConferencesMissed"
      >
        {{ $t('calls-history.delete') }}
      </Btn>
    </div>
    <p v-if="loading" class="mrgt-- mrgb0">
      {{ $t('common.loading') }}
    </p>
    <TransitionList v-else-if="missedCalls.length">
      <li
        v-for="(conference, index) in missedCalls"
        :key="index"
        class="list-item"
      >
        <Call
          :conference="conference"
          :enable-emergency-call="false"
          @call-started="handleCallRequested(conference)"
        />
      </li>
    </TransitionList>
    <p v-else class="text-muted mrgt-- mrgb0">
      {{ $t('calls-history.missed.empty') }}
    </p>

    <div v-if="loadMore" class="mrgt">
      <Btn variant="link" block @click.stop="updateMissedCalls()">
        {{ $t('calls-history.load-more') }}
      </Btn>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

import { getConferencesMissed, deleteConferenceMissed } from '@/services/voip';

import TransitionList from '@/components/transitions/List';
import Call from './Call';

export default {
  components: {
    Call,
    TransitionList,
  },

  data() {
    return {
      loading: true,
      limit: 5,
      offset: 0,
      loadMore: false,
      missedCalls: [],
    };
  },

  mounted() {
    this.updateMissedCalls();
  },

  methods: {
    ...mapMutations('ui', ['setCallHistoryPanelVisibility']),

    updateMissedCalls() {
      getConferencesMissed(this.limit, this.offset).then(response => {
        this.missedCalls = [...this.missedCalls, ...response.data];
        this.loading = false;
        this.offset += this.limit;
        this.loadMore = response.data && this.limit === response.data.length;
      });
    },

    deleteConferencesMissed() {
      this.missedCalls.forEach(missedCall => {
        deleteConferenceMissed(missedCall.id);
      });

      this.missedCalls = [];
      this.offset = 0;
    },

    handleCallRequested(conf) {
      this.setCallHistoryPanelVisibility(false);
      deleteConferenceMissed(conf.id);
    },
  },
};
</script>
